module.exports = __webpack_public_path__ + "static/media/icon-salon.651212bb.svg";